import { useEffect, useMemo, useState } from 'react';

import { AppointmentsLifecycleEnum } from '@/types/enums/appointments.enum';

export enum AppointmentsTabsEnum {
  FUTURE = 'SCHEDULED',
  PAST = 'ARRIVAL_ORDER',
  OTHER = 'OTHER',
}

export type TabItem = { title: string; key: AppointmentsTabsEnum; queryKey: AppointmentsLifecycleEnum };

export const TABS_LABELS: Record<AppointmentsTabsEnum, TabItem> = {
  [AppointmentsTabsEnum.FUTURE]: {
    title: 'Próximos',
    key: AppointmentsTabsEnum.FUTURE,
    queryKey: AppointmentsLifecycleEnum.FUTURE,
  },
  [AppointmentsTabsEnum.PAST]: {
    title: 'Realizados',
    key: AppointmentsTabsEnum.PAST,
    queryKey: AppointmentsLifecycleEnum.PAST,
  },
  [AppointmentsTabsEnum.OTHER]: {
    title: 'Pendentes',
    key: AppointmentsTabsEnum.OTHER,
    queryKey: AppointmentsLifecycleEnum.OTHER,
  },
} as const;

interface AppointmentsTabsProps {
  hasFutureAppointments: boolean;
  hasPastAppointments: boolean;
  hasOtherAppointments: boolean;
}

export function useAppointmentsTabs({
  hasFutureAppointments,
  hasPastAppointments,
  hasOtherAppointments,
}: AppointmentsTabsProps) {
  const [activeTab, setActiveTab] = useState<AppointmentsTabsEnum>();

  const tabs = useMemo(() => {
    const tabs: TabItem[] = [];

    if (hasFutureAppointments) {
      tabs.push(TABS_LABELS[AppointmentsTabsEnum.FUTURE]);
    }

    if (hasPastAppointments) {
      tabs.push(TABS_LABELS[AppointmentsTabsEnum.PAST]);
    }

    if (hasOtherAppointments) {
      tabs.push(TABS_LABELS[AppointmentsTabsEnum.OTHER]);
    }

    return tabs;
  }, [hasFutureAppointments, hasPastAppointments, hasOtherAppointments]);

  useEffect(() => {
    if (tabs.length > 0) {
      setActiveTab(tabs?.[0].key);
    }
  }, [tabs]);

  return { tabs, activeTab, onTabSelect: (tab: string) => setActiveTab(tab as AppointmentsTabsEnum) };
}
